import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import AppRow from "@/components/AppRow";
import LoadError from "@/components/LoadError";
import { apiErrorMessage } from "@/lib/apiResponses";

export default function CategoryView() {
  const { name } = useParams();
  const [apps, setApps] = useState(null);
  const [error, setError] = useState(null);
  const [retry, setRetry] = useState(0);
  const cat = decodeURIComponent(name || "");

  useEffect(() => {
    const controller = new AbortController();
    setApps(null);
    setError(null);
    api.apps({ category: cat }, { signal: controller.signal })
      .then((data) => { if (!controller.signal.aborted) setApps(data); })
      .catch((e) => { if (!controller.signal.aborted) setError(apiErrorMessage(e)); });
    return () => controller.abort();
  }, [cat, retry]);

  return (
    <div className="pb-28">
      <Header title={cat} subtitle="Категория" back />
      <div className="px-4 pt-2">
        {error ? (
          <LoadError message={error} onRetry={() => setRetry((n) => n + 1)} testId="category-error" />
        ) : apps === null ? (
          <div className="py-10 text-center text-slate-500">Загрузка…</div>
        ) : apps.length === 0 ? (
          <div className="py-10 text-center text-slate-500">В этой категории пока пусто.</div>
        ) : (
          <div className="divide-y divide-white/5">
            {apps.map((app, i) => (
              <AppRow key={app.id} app={app} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
